// extracted by mini-css-extract-plugin
export default {"table":"table--R0Ex2","column2":"column2--gJEuo"};